import Component from './twitter_prize_table.vue'
export default Component
